import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    companyName: "",
    contactPerson: "",
    phone: "",
    workEmail: "",
    productDetails: "",
    agreeToTerms: false,
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Submit function using fetch
  const handleSubmit = async (e) => {
    // e.preventDefault();
    console.log("Form Data Submitted:", formData);

    try {
      if (
        !formData.companyName ||
        !formData.contactPerson ||
        !formData.phone ||
        !formData.workEmail ||
        !formData.productDetails
      ) {
        throw new Error("Please fill in all required fields");
      }

      const response = await fetch(
        "https://server.surveysiq.com/api/submitBrandInquiry",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to submit the form");
      }

      setFormData({
        companyName: "",
        contactPerson: "",
        phone: "",
        workEmail: "",
        productDetails: "",
      });
      toast.success("Form submitted successfully!");
    } catch (error) {
      toast.error(error.message || "An error occurred");
      console.error("Form submission error:", error);
    }
  };
  return (
    <div
      id="contact-form"
      className="min-h-screen flex items-center bg-mint-glass justify-center pt-8 p-4"
    >
      <div className="w-full max-w-xl bg-white rounded-lg p-4">
        {/* Header */}
        <div className="text-center max-w-xl mb-12 mt-4 px-0">
          <h1 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-2">
            Create Your Company Account
          </h1>
          <p className="text-lg text-gray-600">
            Join thousands of companies already using SurveysIQ
          </p>
        </div>

        {/* Form */}
        <div className="space-y-4">
          {/* Company Name and Contact Person Row */}
          <div className="flex gap-4">
            <div className="flex-1">
              <label className="block text-sm text-gray-700 mb-2 font-normal">
                Company Name
              </label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleInputChange}
                placeholder="Your Company Name"
                className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              />
            </div>
            <div className="flex-1">
              <label className="block text-sm text-gray-700 mb-2 font-normal">
                Contact Person
              </label>
              <input
                type="text"
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleInputChange}
                placeholder="Your Full Name"
                className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-2 font-normal">
              Phone
            </label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="Your Phone Number"
              className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            />
          </div>

          {/* Work Email */}
          <div>
            <label className="block text-sm text-gray-700 mb-2 font-normal">
              Work Email
            </label>
            <input
              type="email"
              name="workEmail"
              value={formData.workEmail}
              onChange={handleInputChange}
              placeholder=""
              className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            />
          </div>

          {/* Product Description */}
          <div>
            <label className="block text-sm text-gray-700 mb-2 font-normal">
              Tell us in detail about your product
            </label>
            <textarea
              name="productDetails"
              value={formData.productDetails}
              onChange={handleInputChange}
              rows={3}
              className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded resize-none focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            />
          </div>

          {/* Terms Checkbox */}
          {/* <div className="flex items-start gap-2 pt-2">
            <input
              type="checkbox"
              id="terms"
              name="agreeToTerms"
              checked={formData.agreeToTerms}
              onChange={handleInputChange}
              className="mt-0.5 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            /> */}
          {/* <label htmlFor="terms" className="text-xs text-gray-600 leading-4">
              I agree to the{" "}
              <a href="#" className="text-blue-600 hover:underline">
                Terms of Service
              </a>{" "}
              and{" "}
              <a href="#" className="text-blue-600 hover:underline">
                Privacy Policy
              </a>
            </label> */}
          {/* </div> */}

          {/* Get Started Button */}
          <div className="pt-2">
            <button
              type="button"
              onClick={handleSubmit}
              className="w-full bg-green-500 hover:bg-green-600 text-white font-medium py-3 px-4 rounded text-sm transition-colors"
            >
              Get Started
            </button>
          </div>

          {/* Login Link */}
          {/* <div className="text-center pt-2">
            <span className="text-sm text-gray-600">
              Already have an account?{" "}
              <a href="#" className="text-blue-600 hover:underline">
                Log in here
              </a>
            </span>
          </div> */}
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={5000} />
    </div>
  );
}
